import { render } from "./OrgStructure.vue?vue&type=template&id=fcf8387c&scoped=true"
import script from "./OrgStructure.vue?vue&type=script&lang=js"
export * from "./OrgStructure.vue?vue&type=script&lang=js"

import "./org-structure.scss?vue&type=style&index=0&id=fcf8387c&lang=scss&scoped=true"
import "./OrgStructure.vue?vue&type=style&index=1&id=fcf8387c&lang=scss"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcf8387c"]])

export default __exports__